import VueSocket from '@/libs/vue3-socket-io';

import {useWebsocketStore} from '@/stores/websocketStore';

export const initSocket = async app => {
  // Tạm fake vuex và sửa thư viện do ko muốn viết lại code
  const store = useWebsocketStore();
  app.use(new VueSocket({vuex: {store}}));
};
